/**
 * Exposes method for converting a country code to a currency.
 */
export class CountryCodeToCurrency {
  /**
   * Convert by giving a country code
   */
  public static convert(countryCode: string): string | null {
    const list = {
      'AF': 'AFN',
      'AL': 'ALL',
      'DZ': 'DZD',
      'AD': 'EUR',
      'AO': 'AOA',
      'AG': 'XCD',
      'AR': 'ARS',
      'AM': 'AMD',
      'AU': 'AUD',
      'AT': 'EUR',
      'AZ': 'AZN',
      'BS': 'BSD',
      'BH': 'BHD',
      'BD': 'BDT',
      'BB': 'BBD',
      'BY': 'BYN',
      'BE': 'EUR',
      'BZ': 'BZD',
      'BT': 'BTN',
      'BO': 'BOB',
      'BA': 'BAM',
      'BW': 'BWP',
      'BR': 'BRL',
      'BN': 'BND',
      'BG': 'BGN',
      'BF': 'XOF',
      'BI': 'BIF',
      'KH': 'KHR',
      'CA': 'CAD',
      'CV': 'CVE',
      'CF': 'XAF',
      'TD': 'XAF',
      'CL': 'CLP',
      'CN': 'CNY',
      'CO': 'COP',
      'KM': 'KMF',
      'CR': 'CRC',
      'HR': 'HRK',
      'CU': 'CUP',
      'CY': 'EUR',
      'CZ': 'CZK',
      'DK': 'DKK',
      'DJ': 'DJF',
      'DM': 'XCD',
      'TL': 'USD',
      'EC': 'USD',
      'EG': 'EGP',
      'GQ': 'USD',
      'SV': 'XAF',
      'ER': 'ERN',
      'EE': 'EUR',
      'SZ': 'SZL',
      'ET': 'ETB',
      'FJ': 'FJD',
      'FI': 'EUR',
      'FR': 'EUR',
      'GA': 'XAF',
      'GM': 'GMD',
      'GE': 'GEL',
      'DE': 'EUR',
      'GH': 'GHS',
      'GR': 'EUR',
      'WG': 'XCD',
      'GT': 'GTQ',
      'GN': 'GNF',
      'GW': 'XOF',
      'GY': 'GYD',
      'HT': 'HTG',
      'HN': 'HNL',
      'HU': 'HUF',
      'IS': 'ISK',
      'IN': 'INR',
      'ID': 'IDR',
      'IR': 'IRR',
      'IQ': 'IQD',
      'IE': 'EUR',
      'IL': 'ILS',
      'IT': 'EUR',
      'CI': 'XOF',
      'JM': 'JMD',
      'JP': 'JPY',
      'JO': 'JOD',
      'KZ': 'KZT',
      'KE': 'KES',
      'KI': 'AUD',
      'KP': 'KPW',
      'KR': 'KRW',
      'XK': 'EUR',
      'KW': 'KWD',
      'KG': 'KGS',
      'LA': 'LAK',
      'LV': 'EUR',
      'LB': 'LBP',
      'LS': 'LSL',
      'LR': 'LRD',
      'LY': 'LYD',
      'LI': 'CHF',
      'LT': 'EUR',
      'LU': 'EUR',
      'MG': 'MGA',
      'MW': 'MWK',
      'MY': 'MYR',
      'MV': 'MVR',
      'ML': 'XOF',
      'MT': 'EUR',
      'MH': 'USD',
      'MR': 'MRO',
      'MU': 'MUR',
      'MX': 'MXN',
      'FM': 'USD',
      'MD': 'MDL',
      'MC': 'EUR',
      'MN': 'MNT',
      'ME': 'EUR',
      'MA': 'MAD',
      'MZ': 'MZN',
      'MM': 'MMK',
      'NA': 'NAD',
      'NR': 'AUD',
      'NP': 'NPR',
      'NL': 'EUR',
      'NZ': 'NZD',
      'NI': 'NIO',
      'NE': 'XOF',
      'NG': 'NGN',
      'MK': 'MKD',
      'NO': 'NOK',
      'OM': 'OMR',
      'PK': 'PKR',
      'PW': 'USD',
      'PS': 'ILS',
      'PA': 'PAB',
      'PG': 'PGK',
      'PY': 'PYG',
      'PE': 'PEN',
      'PH': 'PHP',
      'PL': 'PLN',
      'PT': 'EUR',
      'QA': 'QAR',
      'CD': 'XAF',
      'RO': 'RON',
      'RU': 'RUB',
      'RW': 'RWF',
      'KN': 'XCD',
      'LC': 'XCD',
      'VC': 'XCD',
      'WS': 'WST',
      'SM': 'EUR',
      'ST': 'STD',
      'SA': 'SAR',
      'SN': 'XOF',
      'RS': 'RSD',
      'SC': 'SCR',
      'SL': 'SLL',
      'SI': 'EUR',
      'SB': 'SBD',
      'SO': 'SOS',
      'ZA': 'ZAR',
      'SS': 'SSP',
      'ES': 'EUR',
      'LK': 'LKR',
      'SD': 'SDG',
      'SR': 'SRD',
      'SE': 'SEK',
      'CH': 'CHF',
      'SY': 'SYP',
      'TW': 'TWD',
      'TJ': 'TJS',
      'TZ': 'TZS',
      'TH': 'THB',
      'TG': 'XOF',
      'TO': 'TOP',
      'TT': 'TTD',
      'TN': 'TND',
      'TR': 'TRY',
      'TM': 'TMT',
      'TV': 'AUD',
      'UG': 'UGX',
      'UA': 'UAH',
      'AE': 'AED',
      'GB': 'GBP',
      'US': 'USD',
      'UZ': 'UZS',
      'VU': 'VUV',
      'VA': 'EUR',
      'VE': 'VEF',
      'VN': 'VND',
      'YE': 'YER',
      'ZM': 'ZMW',
      'ZW': 'USD'
    }

    return list[(countryCode || '').toUpperCase()] || null;
  }
}
